import { Project } from '../types';

export const encodeProject = (project: Project): string => {
  try {
    const jsonString = JSON.stringify(project);
    const base64 = btoa(encodeURIComponent(jsonString));
    return base64;
  } catch (err) {
    throw new Error('项目序列化失败');
  }
};

export const decodeProject = (encoded: string): Project => {
  try {
    const base64 = decodeURIComponent(atob(encoded));
    const jsonString = base64;
    const project = JSON.parse(jsonString);
    return project;
  } catch (err) {
    throw new Error('项目反序列化失败');
  }
};

export const generateShareLink = (project: Project): string => {
  const encoded = encodeProject(project);
  return `${window.location.origin}${window.location.pathname}?project=${encoded}`;
};

export const getProjectFromUrl = (): Project | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const encoded = urlParams.get('project');

  if (encoded) {
    try {
      return decodeProject(encoded);
    } catch (err) {
      console.error('Failed to load project from URL:', err);
      return null;
    }
  }

  return null;
};

export const downloadProject = (project: Project) => {
  const encoded = encodeProject(project);
  const blob = new Blob([encoded], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${project.name}.json`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const generateEmbedCode = (project: Project, width = 800, height = 600): string => {
  const shareLink = generateShareLink(project);
  return `<iframe src="${shareLink}" width="${width}" height="${height}" frameborder="0"></iframe>`;
};
